import { render } from "./ExamReportTab.vue?vue&type=template&id=2c1624c6&scoped=true"
import script from "./ExamReportTab.vue?vue&type=script&lang=js"
export * from "./ExamReportTab.vue?vue&type=script&lang=js"

import "./ExamReportTab.vue?vue&type=style&index=0&id=2c1624c6&lang=scss&scoped=true"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2c1624c6"]])

export default __exports__